export const MuiButtonBase = (theme) => {
    const { other: { outline } } = theme.palette;
    return {
        defaultProps: {
            disableRipple: true
        },
        styleOverrides: {
            root: {
                '&.Mui-focusVisible': {
                    outline: '2px solid',
                    outlineColor: outline,
                    outlineOffset: '4px'
                }
            }
        }
    };
};
